import { FileUploaderVariantType } from '../../../../../components/fileUploader/types/fileUploaderVariantType';
import { KubitSelectorBoxFileVariantType } from '../variants';
export const getFileUploaderStyles = (FOUNDATIONS, FONT) => {
    return {
        [FileUploaderVariantType.REGULAR]: {
            selectorBoxFile: {
                variant: KubitSelectorBoxFileVariantType.REGULAR,
            },
        },
    };
};
//# sourceMappingURL=styles.js.map